/*
 * MoreThanPlatform Component
 * Purpose: Display software solutions with interactive cards
 * Author: Jinto Jose
 * Optimized: Mobile-first responsive design with best practices
 */

import React, { useMemo } from 'react';
import styles from './MoreThanPlatform.module.css';

// Constants
const ASSETS = {
  network: '../../Assets/Images/homepage/softwares/network.svg',
  remote: '../../Assets/Images/homepage/softwares/remote.svg',
  video: '../../Assets/Images/homepage/softwares/video.svg',
  analyze: '../../Assets/Images/morethanaplatform/analyze.svg',
  solutionMain: '../../Assets/Images/solutions/solutionMain.svg'
};

const SOLUTIONS_DATA = [
  {
    id: 'networked-drones',
    label: 'Networked Drones',
    content: 'Connect multiple drones into a Networked Drone formation and create a peer to peer or mesh network.',
    image: ASSETS.network,
    path: '/networked-drones',
    alt: 'Networked drone formation illustration'
  },
  {
    id: 'remote-control',
    label: 'Remote Control',
    content: 'Connect to one or more powerful Remote controllers with full video streaming and play back capability.',
    image: ASSETS.remote,
    path: '/remote-control',
    alt: 'Remote controller with video streaming'
  },
  {
    id: 'video-streaming',
    label: 'Video Streaming',
    content: 'Connect to a laptop or stream video and data over the internet with axldrone\'s powerful software solutions.',
    image: ASSETS.video,
    path: '/video-streaming',
    alt: 'Video streaming and data connectivity'
  }
];

const MoreThanPlatform = () => {
  // Memoized solutions data
  const solutionsData = useMemo(() => SOLUTIONS_DATA, []);

  return (
    <section className={styles.solutionsContainer} aria-label="Software Solutions">
      <div className={styles.solutionsGrid}>
        {solutionsData.map((solution) => (
          <article
            key={solution.id}
            className={styles.solutionCard}
          >
            {/* Image Container */}
            <div className={styles.imageContainer}>
              <img 
                src={solution.image} 
                alt={solution.alt}
                className={styles.solutionImage}
                loading="lazy"
              />
            </div>

            {/* Content Container */}
            <div className={styles.contentContainer}>
              {solution.label && (
                <h3 className={styles.solutionTitle}>{solution.label}</h3>
              )}
              <p className={styles.solutionDescription}>{solution.content}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default MoreThanPlatform;